import React from 'react';
import { createRoot } from 'react-dom/client';
import store, { persistor } from './redux/store';
import { Provider } from 'react-redux';
import { PersistGate } from 'reduxjs-toolkit-persist/integration/react';
import * as Sentry from '@sentry/react';
import { BrowserTracing } from '@sentry/tracing';
import * as serviceWorker from './serviceWorkerRegistration';
import App from './modules/Rider';
import './fonts/fonts.css';
import { ConfirmContextProvider } from './Context';
import { CancelSamplesPopup } from './modules/Rider/Popups';

// Sentry Configurations
if (process.env.REACT_APP_ENABLE_SENTARY === 'true') {
  Sentry.init({
    dsn: process.env.REACT_APP_SENTARY_DSN,
    environment: process.env.REACT_APP_SENTRY_ENVIRONMENT,
    integrations: [new BrowserTracing()],
    tracesSampleRate: 1.0,
  });
}

const rootElement = document.getElementById('app');
const root = createRoot(rootElement);
root.render(
  <Provider store={store}>
    <PersistGate persistor={persistor}>
      <ConfirmContextProvider>
        <App />
        <CancelSamplesPopup />
      </ConfirmContextProvider>
    </PersistGate>
  </Provider>
);

serviceWorker.register();
